export default __webpack_public_path__ + "2474abaa9c1c5b5beb32cd02d8877959.webp";